import { Product } from 'core/types/product';

import { Action, SET_CUSTOMER_PRODUCTS } from './actions';

interface CutsomerProductsState {
  [key: string]: Array<Product & { pivot: { price: number } }>;
}

export default (
  state: CutsomerProductsState = {},
  action: Action
): CutsomerProductsState => {
  switch (action.type) {
    case SET_CUSTOMER_PRODUCTS:
      return { ...state, [action.payload.customer]: action.payload.products };
    default:
      return state;
  }
};
